import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './Why.module.scss';

export const WhyStepOneSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>Why</div>
        <div className={styles.stepSection_2}>
          Transparen <br /> Terra?
        </div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        To save the world and ensure a sustainable future, each of us must act consciously.
        Therefore, to change the world for the better, we need ESG principles, research, roadmaps,
        and tools. TransparenTerra’s experts and analysts will help reduce CO2 emissions, find
        suitable renewable energy sources, and foster regenerative agriculture, conscious
        consumption, and a circular economy.
      </div>
    }
  />
);
